import { render, staticRenderFns } from "./BodyArrayItem.vue?vue&type=template&id=671e4081&"
import script from "./BodyArrayItem.vue?vue&type=script&lang=js&"
export * from "./BodyArrayItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports